import { render, staticRenderFns } from "./FormUlanqab.vue?vue&type=template&id=5406a68a&scoped=true"
import script from "./FormUlanqab.vue?vue&type=script&lang=js"
export * from "./FormUlanqab.vue?vue&type=script&lang=js"
import style0 from "./FormUlanqab.vue?vue&type=style&index=0&id=5406a68a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5406a68a",
  null
  
)

export default component.exports